import {useSpaceSelection} from '@github-ui/copilot-spaces/hooks/use-space-selection'
import {ToggleButton} from '@github-ui/pacer/ToggleButton'
import {TasklistIcon} from '@primer/octicons-react'
import {Button, Tooltip} from '@primer/react'
import {useCallback} from 'react'

import {useChatStateValues} from '../utils/CopilotChatContext'
import {useChatManager} from '../utils/CopilotChatManagerContext'

export function PlanningIntentToggle() {
  const manager = useChatManager()
  const {usePlanningIntent, selectedThreadID} = useChatStateValues('usePlanningIntent', 'selectedThreadID')
  const {activeCopilotSpaceId} = useSpaceSelection()
  const onClick = useCallback(() => manager.setUsePlanningIntent(!usePlanningIntent), [manager, usePlanningIntent])

  if (activeCopilotSpaceId) {
    return (
      <Tooltip text="Planning mode is not available when a Space is selected.">
        <Button leadingVisual={TasklistIcon} inactive aria-disabled>
          Plan
        </Button>
      </Tooltip>
    )
  }

  if (selectedThreadID) {
    return (
      <Tooltip text="Planning mode is enabled and cannot be toggled after the conversation has started.">
        <Button leadingVisual={TasklistIcon} inactive aria-disabled aria-pressed>
          Plan
        </Button>
      </Tooltip>
    )
  }

  return (
    <ToggleButton icon={<TasklistIcon />} isSelected={usePlanningIntent} onClick={onClick}>
      Plan
    </ToggleButton>
  )
}

try{ PlanningIntentToggle.displayName ||= 'PlanningIntentToggle' } catch {}